// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".option[data-v-d79b6f7a]{--icon-size:32px;display:flex;align-items:center;grid-gap:8px;gap:8px}.option-image[data-v-d79b6f7a]{width:var(--icon-size);height:auto;display:block;padding-top:4px;flex-shrink:0}.text[data-v-d79b6f7a]{display:flex;flex-direction:column}.option-text[data-v-d79b6f7a]{font-weight:700}.option-subtext[data-v-d79b6f7a]{color:#6a6a6a;font-size:.875rem;line-height:1.2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
